import { gql } from "@apollo/client";

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_REVIEW = gql`
  mutation UpdateOneUser(
    $data: UserUpdateInput!
    $where: UserWhereUniqueInput!
  ) {
    updateOneUser(data: $data, where: $where) {
      id
      firstName
      lastName
      reviews {
        dateCompleted
        dateToCompleteBy
        manager
        status
        title
        year
        evaluations {
          dateCompleted
          dateToCompleteBy
          status
          author
          formAuthor
          manager
          owner
          sections {
            instructions
            questions {
              answerOptions {
                value
                name
              }
              answer
              answerType
              text
            }
            title
          }
          title
        }
      }
    }
  }
`;

export const CREATE_REVIEW_TEMPLATE = gql`
  mutation createOneReviewTemplate($data: ReviewTemplateCreateInput!) {
    createOneReviewTemplate(data: $data) {
      id
    }
  }
`;

export const ASSIGN_REVIEW_TO_USER = gql`
  mutation assignReviewToUser(
    $employeeNumber: String!
    $templateVersionId: String!
    $dateToCompleteBy: String!
  ) {
    assignReviewToUser(
      employeeNumber: $employeeNumber
      templateVersionId: $templateVersionId
      dateToCompleteBy: $dateToCompleteBy
    ) {
      id
    }
  }
`;
